import './../styles/Staking.css';

export default function Staking() {
  return (
    <>
      {/* ---- Build on it. Back it. ---- */}
      <section className="build-banner">
        <div className="build-banner__text">
          <h2>
            Build on it.
            <br />
            Back it.
          </h2>
          <p>
            Two ways in: build credentialed applications on Zilliqa's infrastructure, or stake ZIL
            to participate in network economics, fees generated by every credential check.
          </p>
        </div>
        <div className="build-banner__actions">
          <a className="zq-btn zq-btn--solid zq-btn--lg" href="https://dev.zilliqa.com/zilliqa2/">
            Start Building
          </a>
          <a className="zq-btn zq-btn--outline-dark zq-btn--lg" href="https://stake.zilliqa.com/">
            Start Earning
          </a>
        </div>
      </section>

      {/* ---- Stake the normal way (purple) ---- */}
      <section className="stake-panel stake-panel--purple">
        <span className="stake-panel__eyebrow">STAKE THE NORMAL WAY</span>
        <div className="stake-panel__body">
          <h3>Lock assets and claim rewards</h3>
          <p>
            Your ZIL is securely staked with a validator to earn rewards and remains locked
            during the process.
          </p>
          <a className="zq-btn zq-btn--outline zq-btn--lg" href="https://stake.zilliqa.com/">
            Start Now
          </a>
        </div>
        <div className="stake-panel__image">
          <img
            src={`${process.env.PUBLIC_URL}/images/staking-widget-non-liquid.png`}
            alt="Non-liquid staking dashboard"
          />
        </div>
      </section>

      {/* ---- Stake the liquid way (teal) ---- */}
      <section className="stake-panel stake-panel--teal">
        <span className="stake-panel__eyebrow stake-panel__eyebrow--dark">
          STAKE THE LIQUID WAY
        </span>
        <div className="stake-panel__body">
          <h3 className="stake-panel__heading--dark">Stake and keep liquidity</h3>
          <p className="stake-panel__text--dark">
            This means you can continue to use your staked assets in other financial activities,
            such as trading or investing, while still securing the network.
          </p>
          <a className="stake-panel__textlink" href="https://stake.zilliqa.com/">
            Start Now
          </a>
        </div>
        <div className="stake-panel__image">
          <img
            src={`${process.env.PUBLIC_URL}/images/staking-widget-liquid.png`}
            alt="Liquid staking dashboard"
          />
        </div>
      </section>
    </>
  );
}